module.exports = __webpack_public_path__ + "img/logo_garmin.a4b236bd.svg";